import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "next-i18next";

import { Typography } from "@/components/index";
import { flagPlaceholder, makeLangImage } from "@/shared/utils/url/url";
import { getOptionKey } from "@/shared/utils/select";
import { Backdrop, IconView } from "@/shared/components";
import { LANDING_SELECTORS } from "@/utils/landing/landing.constants";
import useLockBodyScroll from "@/shared/hooks/useLockBodyScroll";
import EgwWebFont from "src/assets/EgwWebFont";

import styles from "./langPopup.module.scss";

const LangPopup = ({
  title,
  langs,
  withAll,
  className,
  classNameScroll,
  classNameModal,
  isOpen,
  setIsOpen,
  onClickItem,
}) => {
  const { t } = useTranslation();

  useLockBodyScroll(isOpen);

  const renderItem = (item) => {
    const itemId = getOptionKey(item);
    const imageUrl = makeLangImage(itemId, false);

    return (
      <>
        <img
          width={256}
          alt={item.code}
          role="presentation"
          loading="lazy"
          className={styles["lang-sel-img"]}
          src={imageUrl}
          onError={(e) => {
            if (e.target.src.indexOf("flags") > -1) {
              e.target.src = flagPlaceholder;
            }
          }}
        />
        <Typography
          className={styles["label"]}
          hoverable
          variant={Typography.variant.body4}
          color={Typography.color.inherit}>
          {t(item.label)}
        </Typography>
      </>
    );
  };

  let modalStyle = {
    display: "none",
  };

  if (isOpen) {
    modalStyle.display = "block";
  }

  return (
    <div style={modalStyle} className={classNames(styles["modal"], classNameModal)}>
      <div className={classNames(styles["modal-root"])}>
        <Typography variant="h2" className={styles["title"]}>
          {t(title)}
        </Typography>
        <div
          className={classNames(
            styles["root"],
            className,
            LANDING_SELECTORS.langDialogWrapperClass.substring(1),
          )}>
          <div className={classNames(styles["scroll-view"], classNameScroll)}>
            {withAll && (
              <div
                onClick={() => onClickItem(-1)}
                data-lang={"all"}
                className={classNames(
                  styles["item-lang"],
                  LANDING_SELECTORS.langDialogItemClass.substring(1),
                )}>
                <IconView
                  icon={EgwWebFont.translation}
                  className={styles["reader-translate-icon"]}
                />
                <span>{t("all")}</span>
              </div>
            )}
            {langs.map((item) => {
              const id = getOptionKey(item);
              return (
                <div
                  key={id}
                  data-lang={id}
                  onClick={() => onClickItem(id)}
                  className={classNames(
                    styles["item-lang"],
                    LANDING_SELECTORS.langDialogItemClass.substring(1),
                  )}>
                  {renderItem(item)}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Backdrop
        id={LANDING_SELECTORS.langDialogBackdrop.substring(1)}
        className={styles["backdrop"]}
        onClick={() => setIsOpen(false)}
        clickable={true}
      />
    </div>
  );
};

LangPopup.propTypes = {
  langs: PropTypes.array,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default LangPopup;
